"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findWithdrawalById = void 0;
const findWithdrawalById = (serverURL, appAxios) => async withdrawalId => await appAxios.get(`${serverURL}/withdrawals/${withdrawalId}`, {
  withCredentials: true
});
exports.findWithdrawalById = findWithdrawalById;